import {Component, OnInit} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserProfile } from 'app/profile/model/model';
import { UserService } from 'app/profile/services/user.service';

import { Browser } from '@capacitor/browser';

import {NavService} from 'shared/nav/nav.service';
import { zip } from 'rxjs';
import { HyphenateService } from 'shared/helpers/hyphenate.service';
import { DefaultMenuPage } from '../default-menu-page/default-menu-page';

@Component({
  selector: 'corefacts-page',
  templateUrl: 'corefacts-page.html',
  styleUrls: ['corefacts-page.scss'],
})
export class CoreFactsPage extends DefaultMenuPage implements OnInit {

  public lineY = '';

  public brand: Dictionary<string> = {}

  constructor(
    public navService: NavService,
    private userService: UserService,
    private translateService: TranslateService,
    private hyphenateService: HyphenateService,
  ) {
    super(navService, translateService);
    if ( navService.get('lineY') !== undefined ) {
      this.lineY = (navService.get('lineY')-56-24)+'px'; // TODO: Header-Höhe und halbe Itemhöhe
      // console.log("## "+navService.get('lineY')+'px');
    }
    this.userService.getUserProfile('full')
    .subscribe((profile: UserProfile) => {
      let data = [];
      if ( this.hyphenateService.getTargetGroup() !== undefined ) {
        data.push(this.hyphenateService.getTargetGroup());
      }
      if ( profile.company.name !== undefined ) {
        data.push(profile.company.name);
      }
      if ( this.userService.getCompanyThemes(profile) !== undefined ) {
        data = data.concat(this.userService.getCompanyThemes(profile));
      }
      data = data.map(name => name.toUpperCase());
      zip(
        this.translateService.get(data.map(name => "COREFACTS.COMPANY." + name + ".MAIN")),
        this.translateService.get(data.map(name => "COREFACTS.COMPANY." + name + ".INFO")),
        this.translateService.get(data.map(name => "COREFACTS.COMPANY." + name + ".MATERIAL")),
        this.translateService.get(data.map(name => "COREFACTS.COMPANY." + name + ".CONTACT")),
      ).subscribe((translations) => {
        this.brand['MAIN'] = this.firstValue(translations[0], data, 'MAIN');
        this.brand['INFO'] = this.firstValue(translations[1], data, 'INFO');
        this.brand['MATERIAL'] = this.firstValue(translations[2], data, 'MATERIAL');
        this.brand['CONTACT'] = this.firstValue(translations[3], data, 'CONTACT');
      });
    });  
  }

  private firstValue(cand: Dictionary<string>, data: string[], type: string): string {
    for (let i = 0; i < data.length; i++) {
      const key = "COREFACTS.COMPANY." + data[i] + '.' + type;
      const s = cand[key];
      if ( s !== undefined && s != null && s != '' && s != key ) {
        return s;
      }
    }
    return 'none';
  }

  public ngOnInit(): void {
  }

  public showCompanyPage(type: string): void {
    const s = this.brand[type];
    console.log(s);
    if (s == 'none') {
      return;
    }
    if (s.startsWith('https://') || s.startsWith('http://')) {
      Browser.open({url: s.replace(/\u00AD/g, '')});
    }
    else {
      this.navService.push('corefacts/generic', {type: type, data: s});
    }
  }

  public openLink(link: string): void {
    this.translateService
      .get('HELP.LINKS.' + link)
      .subscribe((url: string) => {
        Browser.open({url: url.replace(/\u00AD/g, '')});
      });
  }

}
